import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getInsuranceProviders } from '../api/insuranceProviders';
import { PROVIDER_SOURCE, getContractorProviderInsurerMap } from '../constants/quote';
import { GoodsInTransitKey, businessInsuranceKey, getBusinessInsuranceOldCompatibilityTypeList, getBusinessInsuranceTypes, goodsInTransitOldCompatibilityKey } from '../localeConstants';
import { Regions } from '../shared/generated';
export var insurerStore = create()(immer(function (set, get) {
  return {
    state: {
      insurerList: []
    },
    actions: {
      fetchInsurerList: function () {
        var _fetchInsurerList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var res;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return getInsuranceProviders();

                case 2:
                  res = _context.sent;
                  set(function (store) {
                    store.state.insurerList = ((res === null || res === void 0 ? void 0 : res.data) || []).map(function (item) {
                      return _objectSpread(_objectSpread({}, item), {}, {
                        value: item.code,
                        label: item.name
                      });
                    });
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function fetchInsurerList() {
          return _fetchInsurerList.apply(this, arguments);
        }

        return fetchInsurerList;
      }(),
      getBusinessInsurerTypeListByRegion: function getBusinessInsurerTypeListByRegion(region) {
        var insuranceTypeList = getBusinessInsuranceTypes().filter(function (item) {
          return [GoodsInTransitKey, businessInsuranceKey].includes(item.value);
        });

        if ([Regions.US].includes(region)) {
          insuranceTypeList = getBusinessInsuranceTypes().filter(function (item) {
            return [GoodsInTransitKey].includes(item.value);
          });
        }

        return insuranceTypeList;
      },
      getInsurerListByRegion: function getInsurerListByRegion(region, insurerType) {
        if (region === Regions.US) {
          if (insurerType === GoodsInTransitKey) {
            return [PROVIDER_SOURCE().GREATEAMERICAN];
          } else {
            return [];
          }
        } else {
          if (insurerType === GoodsInTransitKey) {
            return [PROVIDER_SOURCE().ACCELERANT];
          } else {
            return [PROVIDER_SOURCE().ACCELERANT, PROVIDER_SOURCE().RECRUITMENT];
          }
        }
      },
      getBusinessInsurerOldCompatibilityTypeListByRegion: function getBusinessInsurerOldCompatibilityTypeListByRegion() {
        return getBusinessInsuranceOldCompatibilityTypeList().filter(function (item) {
          return [goodsInTransitOldCompatibilityKey, businessInsuranceKey].includes(item.value);
        });
      },
      getOldCompatibilityInsurerListByRegion: function getOldCompatibilityInsurerListByRegion() {
        return [getContractorProviderInsurerMap().accelerant, getContractorProviderInsurerMap().greatAmerican];
      }
    }
  };
}));